import { Component, Input } from '@angular/core';
import { Road } from 'src/app/modules/route-planner/models/route-signposts-model';

@Component({
    selector: 'aa-motorway-signpost',
    templateUrl: './aa-motorway-signpost.component.html',
    styleUrls: ['./aa-motorway-signpost.component.scss'],
    standalone: false
})
export class AaMotorwaySignpostComponent {

  @Input() road: Array<Road>;
  constructor() { }

  get roads() {
    return this.road;
  }

  getClassName(name) {
    return (name.indexOf('M') != -1) ? 'signspot-motorway' : '';
  }
  
  trackByFn(index: number): number {
    return index;
  }
}
